export var API_VERSION;
(function (API_VERSION) {
    API_VERSION["V1"] = "v1";
    API_VERSION["V2"] = "v2";
    API_VERSION["V3"] = "v3";
})(API_VERSION || (API_VERSION = {}));
